/**
 * Get the name of the seller owner of the classifications that are being used in the app.
 *
 * @param {Object} state
 */
function classificationsSellerName(state) {
  const seller = state.availableClassificationsSellers.find(seller => seller.id === state.classificationsSellerId)
  return seller ? seller.name : null
}


/**
 * Get the array of items but ensuring that there are no duplicity between them.
 * @param {Object} state
 */
function itemsWithoutDuplicity(state) {
  const keyedItems = {}
  const items = []
  state.items.forEach(item => {
    const key = `${item.sellerId}-${item.id}`
    if (!keyedItems[key]) {
      items.push(item)
      keyedItems[key] = true
    }
  })

  return items
}


/**
 * A simple getter that returns the items that have the `correct` property as `true`
 * or `false`. If an item has other value in the property it won't be in the returned
 * array.
 * @param {Object} state
 * @returns {Object[]}
 */
function itemsWithCorrectProperty(state) {
  return state.items.filter(item => item.correct === true || item.correct === false)
}

export default {
  classificationsSellerName,
  itemsWithCorrectProperty,
  itemsWithoutDuplicity
}